module.exports = __webpack_public_path__ + "static/img/left-num-row-3.5e2d5458.webp";